var _path, _radialGradient, _circle, _radialGradient2, _circle2, _path2, _linearGradient, _path3, _circle3, _circle4, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Hvac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M46,15H2V9c0-1.105,0.895-2,2-2h40c1.105,0,2,0.895,2,2V15z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "9j9e1CTNXf8854JV7biS7a",
    cx: 41,
    cy: 11,
    r: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 11,
    r: 1.5,
    fill: "url(#9j9e1CTNXf8854JV7biS7a)",
    opacity: 0.3
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "9j9e1CTNXf8854JV7biS7b",
    cx: 37,
    cy: 11,
    r: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 11,
    r: 1.5,
    fill: "url(#9j9e1CTNXf8854JV7biS7b)",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M44,31H4c-1.1,0-2-0.9-2-2V15h44v14C46,30.1,45.1,31,44,31z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9j9e1CTNXf8854JV7biS7c",
    x1: 24,
    x2: 24,
    y1: 13.464,
    y2: 13.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#9j9e1CTNXf8854JV7biS7c)",
    d: "M42,31H6v-2c0-1.105,0.895-2,2-2h32c1.105,0,2,0.895,2,2V31z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 11,
    r: 1,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 11,
    r: 1,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M30,43c-0.552,0-1-0.448-1-1c0-1.064,0.355-2.001,0.64-2.754C29.825,38.758,30,38.296,30,38 s-0.175-0.758-0.36-1.246C29.355,36.001,29,35.064,29,34c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.698,0.26,1.383,0.511,2.045 C31.762,36.71,32,37.337,32,38s-0.238,1.29-0.489,1.955C31.26,40.617,31,41.302,31,42C31,42.552,30.552,43,30,43z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M36,45c-0.552,0-1-0.448-1-1c0-1.249,0.329-2.333,0.619-3.29C35.814,40.062,36,39.451,36,39 s-0.186-1.062-0.381-1.71C35.329,36.333,35,35.249,35,34c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.953,0.271,1.846,0.533,2.71 C37.773,37.503,38,38.252,38,39s-0.227,1.497-0.467,2.29C37.271,42.154,37,43.047,37,44C37,44.552,36.552,45,36,45z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M18,43c-0.552,0-1-0.448-1-1c0-1.064,0.355-2.001,0.64-2.754C17.825,38.758,18,38.296,18,38 s-0.175-0.758-0.36-1.246C17.355,36.001,17,35.064,17,34c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.698,0.26,1.383,0.511,2.045 C19.762,36.71,20,37.337,20,38s-0.238,1.29-0.489,1.955C19.26,40.617,19,41.302,19,42C19,42.552,18.552,43,18,43z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M24,45c-0.552,0-1-0.448-1-1c0-1.249,0.329-2.333,0.619-3.29C23.814,40.062,24,39.451,24,39 s-0.186-1.062-0.381-1.71C23.329,36.333,23,35.249,23,34c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.953,0.271,1.846,0.533,2.71 C25.773,37.503,26,38.252,26,39s-0.227,1.497-0.467,2.29C25.271,42.154,25,43.047,25,44C25,44.552,24.552,45,24,45z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M12,45c-0.552,0-1-0.448-1-1c0-1.249,0.329-2.333,0.619-3.29C11.814,40.062,12,39.451,12,39 s-0.186-1.062-0.381-1.71C11.329,36.333,11,35.249,11,34c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.953,0.271,1.846,0.533,2.71 C13.773,37.503,14,38.252,14,39s-0.227,1.497-0.467,2.29C13.271,42.154,13,43.047,13,44C13,44.552,12.552,45,12,45z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Hvac);
export default __webpack_public_path__ + "static/media/icons8-hvac.74df6748eb764547dad25020333d7e68.svg";
export { ForwardRef as ReactComponent };